
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/auth/partnerships/taba-pay",
      function () {
        return require("private-next-pages/docs/auth/partnerships/taba-pay.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/auth/partnerships/taba-pay"])
      });
    }
  